const React = require("react");
const PropTypes = require("prop-types");

const AbstractSpinnerLoading = require("../../../views/abstractPrimitive/AbstractSpinnerLoading.primitive");

function WhiteSpinnerLoading({ isLoading, color }) {
  return <AbstractSpinnerLoading isLoading={isLoading} color="white" />;
}

WhiteSpinnerLoading.propTypes = {};

module.exports = WhiteSpinnerLoading;



// WEBPACK FOOTER //
// ./assets/react/views/primitive/spinner/WhiteSpinnerLoading.primitive.js